<h2 mat-dialog-title>Manage FAQ</h2>

<form [formGroup]="faqForm" (ngSubmit)="save(faqForm)" autocomplete="off" novalidate>
  <mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <!-- Question -->
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Question</mat-label>
          <textarea matInput formControlName="question" maxlength="140" rows="3"></textarea>
          <mat-error *ngIf="submitted && faqForm.get('question')?.hasError('required')">
            Question is required
          </mat-error>
        </mat-form-field>

        <!-- Answer -->
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Answer</mat-label>
          <textarea matInput formControlName="answer" maxlength="140" rows="3"></textarea>
          <mat-error *ngIf="submitted && faqForm.get('answer')?.hasError('required')">
            Answer is required
          </mat-error>
        </mat-form-field>

        <!-- Seq No -->
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Seq No</mat-label>
          <input matInput type="text" formControlName="seq_no" appNumberOnly />
          <mat-error *ngIf="submitted && faqForm.get('seq_no')?.hasError('required')">
            Seq No is required
          </mat-error>
        </mat-form-field>

        <!-- Active Checkbox -->
        <mat-checkbox formControlName="active">Active</mat-checkbox>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions >
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="submit">Save</button>
  </mat-dialog-actions>
</form>
